import React from "react";
import PropTypes from "prop-types";
import { Copy } from "lucide-react";

import { clx, showSuccessMsg } from "../../../utils/Helpers";
import "./UICopyButton.scss";

/** Icon button that copies `value` to the clipboard and confirms with a success toast. */
const UICopyButton = ({ value, ariaLabel, successMessage, className }) => {
  const handleCopy = async () => {
    if (!value || !navigator?.clipboard) return;
    try {
      await navigator.clipboard.writeText(value);
      showSuccessMsg(successMessage, true);
    } catch {
      // Clipboard may be blocked.
    }
  };

  return (
    <button
      type="button"
      className={clx("ui-copy-button", className)}
      aria-label={ariaLabel}
      onClick={handleCopy}
    >
      <Copy size={14} strokeWidth={1.75} />
    </button>
  );
};

UICopyButton.propTypes = {
  value: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
  /** Already-localized toast text shown after a successful copy. */
  successMessage: PropTypes.string.isRequired,
  className: PropTypes.string,
};

UICopyButton.defaultProps = {
  value: "",
  className: undefined,
};

export default UICopyButton;
